import { useApi } from "@utils/useApi";
import { OrdersClient } from "@lib/ShiOneClient";
import { useQuery } from "@tanstack/react-query";
import ms from "ms";
import { OrdersQueryKeys } from "@features/orders-features/hooks/OrdersQueryKeys";

export function useGetBillTo(
  biOrderId: number | undefined,
  webOrderId: number | undefined,
  orgUnitId: number | undefined,
) {
  const api = useApi(OrdersClient);
  const enabled = !!biOrderId || !!webOrderId;

  const fetchBillTo = async () => {
    return await api.getBillTo(biOrderId, webOrderId, orgUnitId);
  };

  return useQuery({
    queryKey: [OrdersQueryKeys.BillTo, biOrderId, webOrderId, orgUnitId],
    queryFn: fetchBillTo,
    enabled,
    staleTime: ms("45s"),
    refetchOnWindowFocus: false,
    retry: false,
  });
}